import React from 'react';
// import {Link} from 'react-router';
import '../../styles/common/Footer.css';
// import * as pathConstants from '../../constants/pathConstants';

const Footer = () => {
  return (
    // <div id="ita-footer" className="border-container">
    // <div className="">
      // <a className="faq-link" role="button" tabIndex="0">FAQ</a> | <span className="non-mobile">
      //   If you have questions, please complete the </span>
      //   <Link to={pathConstants.pathToHelpRequest}>Help Request Form</Link>
    // </div>
    <span></span>
  );
};

export default Footer;



/** WEBPACK FOOTER **
 ** ./src/components/common/Footer.js
 **/